import { BCPopover } from '@bimser/components';
import { IPopoverProps } from '@bimser/components/dist/BCPopover/entities';
import IconClosePanel from '@bimser/icons/16/close-panel';
import IconMaximizeWindow from '@bimser/icons/16/maximize-window';
import React from 'react';
import ClassNames from '../assets/styles.scss';

export default class RDPopover extends React.Component<IPopoverProps, IState> {
	constructor(props: IPopoverProps) {
		super(props);
		this.state = {
			isOpen: false,
			isExpand: false
		};
		ClassNames;

		this.onClose = this.onClose.bind(this);
		this.onExpand = this.onExpand.bind(this);
		this.onVisibleChange = this.onVisibleChange.bind(this);
	}

	onClose() {
		this.setState({ isOpen: false, isExpand: false });
	}

	onExpand() {
		this.setState({ isExpand: !this.state.isExpand });
	}

	onVisibleChange(isVisible: boolean) {
		this.setState({ isOpen: isVisible, isExpand: isVisible ? this.state.isExpand : false });
	}

	renderHeader() {
		if (typeof this.props.title === 'string') {
			return (
				<div className={ClassNames.PopoverHeader}>
					<span className={ClassNames.PopoverTitle}>{this.props.title}</span>
					{this.props.expandable ? (
						<span
							className={ClassNames.PopoverExpandButton}
							onClick={this.onExpand}
						>
							<IconMaximizeWindow />
						</span>
					) : null}
					<span
						className={ClassNames.PopoverCloseModalButton}
						onClick={this.onClose}
					>
						<IconClosePanel />
					</span>
				</div>
			);
		} else {
			return this.props.title;
		}
	}

	render() {
		const overlayStyle: React.CSSProperties = this.state.isExpand
			? ({ '--expandedPopoverWidth': '800px', '--expandedPopoverHeight': '600px' } as any)
			: ({ '--expandedPopoverWidth': '374px', '--expandedPopoverHeight': '264px' } as any);

		return (
			<BCPopover
				{...this.props}
				title={this.renderHeader()}
				open={this.state.isOpen}
				className={this.props.className}
				overlayClassName={[
					ClassNames.PopoverOverlayClass,
					this.state.isExpand ? ClassNames.PopoverExpanded : ''
				].join(' ')}
				overlayStyle={overlayStyle}
				onOpenChange={this.onVisibleChange}
			/>
		);
	}
}

interface IState {
	isExpand: boolean;
	isOpen: boolean;
}
